import React from 'react';
import type { ApplicationUser } from 'types/ApplicationUser';

export interface UserContextValue {
  currentUser: ApplicationUser | undefined;
}

// Create a context with initial value as null
export const UserContext = React.createContext<UserContextValue | undefined>(
  undefined
);
